<remote-update-domain-app-page-wrapper
  [hasError]="hasError()"
  [isLoading]="isLoading()"
  emptyDescription="No update records available for this device."
  emptyTitle="No update records found."
  [data]="null">
  <div header class="flex items-center justify-between pt-150-rem">
    <h1 class="text-[1.5rem] text-[#292F32] w-full font-semibold">Device update record</h1>
  </div>
  <div content class="mt-300-rem flex flex-col gap-150-rem max-w-7xl">
    <div>
      <mat-card appearance="outlined" class="pt-100-rem pb-200-rem">
        <mat-card-header>
          <mat-card-title>Device identifiers</mat-card-title>
        </mat-card-header>
        <mat-card-content class="mt-150-rem text-container-fg-muted">
          <div class="flex flex-col gap-200-rem">
            <span>Bluetooth-friendly name: {{deviceDetails()?.btFriendlyName}}</span>
            <span>Current firmware version: {{deviceDetails()?.firmwareVersion}}</span>
            <span
              >Last successful remote install: {{ (deviceDetails()?.lastRemoteUpdateInstall ?? 0 |
              formatDateTime) || 'N/A'}}</span
            >
          </div>
        </mat-card-content>
      </mat-card>
    </div>

    <div>
      <mat-card appearance="outlined">
        <mat-card-header class="mt-100-rem">
          <mat-card-title>Update events</mat-card-title>
        </mat-card-header>
        <mat-card-content class="mt-100-rem text-container-fg-muted">
          @if (hasNoUpdateHistory()) {
          <remote-update-domain-empty-state
            title="No update records found."
            description="No update records available for this device."></remote-update-domain-empty-state>
          } @else {
          <div>
            <table
              mat-table
              [dataSource]="dataSource"
              class="full-width-table"
              aria-label="Elements">
              <ng-container matColumnDef="timeStamp">
                <th mat-header-cell *matHeaderCellDef>TIMESTAMP</th>
                <td mat-cell *matCellDef="let element">{{element.timeStamp | formatDateTime}}</td>
              </ng-container>

              <ng-container matColumnDef="event">
                <th mat-header-cell *matHeaderCellDef>EVENT</th>
                <td mat-cell *matCellDef="let element">{{element.event}}</td>
              </ng-container>

              <ng-container matColumnDef="installedFirmwareVersion">
                <th mat-header-cell *matHeaderCellDef>INSTALLED FIRMWARE VERSION</th>
                <td mat-cell *matCellDef="let element">
                  {{element.currentlyInstalledFirmwareVersion ?? '-'}}
                </td>
              </ng-container>

              <ng-container matColumnDef="updateFirmwareVersion">
                <th mat-header-cell *matHeaderCellDef>UPDATE FIRMWARE VERSION</th>
                <td mat-cell *matCellDef="let element">
                  {{element.updateFirmwareVersion ?? '-'}}
                </td>
              </ng-container>

              <ng-container matColumnDef="user">
                <th mat-header-cell *matHeaderCellDef>USER</th>
                <td mat-cell *matCellDef="let element">-</td>
              </ng-container>

              <ng-container matColumnDef="remark">
                <th mat-header-cell *matHeaderCellDef>MESSAGE/DETAILS</th>
                <td mat-cell *matCellDef="let element">{{element.remarks ?? '-'}}</td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>
            <mat-paginator
              [pageSize]="5"
              [pageSizeOptions]="[5, 10, 20]"
              aria-label="Device update records table paginator">
            </mat-paginator>
          </div>
          }
        </mat-card-content>
      </mat-card>
    </div>
  </div>
</remote-update-domain-app-page-wrapper>

